export const AccessLevelType = {
  0: 'Administrador',
  25: 'Gerente',
  50: 'Vendedor + Caixa',
  75: 'Vendedor',
  100: 'Garçom',
  125: 'Somente Delivery',
  175: 'Somente KDS',
};
